import React from "react";

type FileUploadProps = {
  fileName?: string;
  name: string;
  accept?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FileUpload = ({
  name,
  accept,
  onChange,
  fileName,
}: FileUploadProps) => {
  return (
    <div className="">
      <div className="mt-4 flex justify-center text-sm leading-6 text-gray-600">
        <label className="relative cursor-pointer rounded-md bg-white font-semibold text-secondary-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-secondary-600 focus-within:ring-offset-2 hover:text-secondary-500">
          <span>{fileName ?? "Upload a file"}</span>
          <input
            name={name}
            type="file"
            accept={accept}
            onChange={onChange}
            className="absolute inset-0 cursor-pointer opacity-0"
          />
        </label>
        {/*<p className="pl-1">or drag and drop</p>*/}
      </div>
      {fileName && <p className="text-sm font-bold">{fileName}</p>}
    </div>
  );
};

export const FileUploadContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
      <div className="text-center">{children}</div>
    </div>
  );
};

export const FileUploadHint = ({ children }: { children: React.ReactNode }) => {
  return <p className="text-xs leading-5 text-gray-600">{children}</p>;
};
